module.exports = __webpack_public_path__ + "img/office365.b114c930.png";